import React from 'react';
import { css } from 'emotion';
import { LinkButton } from '@guardian/src-button';
const widthOverride = css `
	iframe {
		min-width: 300px !important;
		max-width: 100%;
	}
`;
export const getDocumentCloudAssetUrl = (embedUrl) => {
    return (embedUrl &&
        embedUrl.replace(new RegExp('https://embed.documentcloud.org/documents/([0-9]+)-([^/]+).*', 'g'), 'https://assets.documentcloud.org/documents/$1/$2.pdf'));
};
export const DocumentBlockComponent = ({ embedUrl, title, width, height, source }) => {
    return (React.createElement("div", { className: widthOverride },
        React.createElement("iframe", { src: embedUrl, title: title, height: height, width: width, allowFullScreen: true, "data-cy": "document-embed" }),
        source === 'DocumentCloud' ? (React.createElement(LinkButton, { priority: "subdued", size: "small", href: getDocumentCloudAssetUrl(embedUrl), title: title, download: true }, "Download original document")) : (React.createElement(React.Fragment, null))));
};
